import { StyledRouterCard as RouterCard } from '@r1-frontend/ui-react/organisms/Card/Router/styled';

export default RouterCard;
